import React, { useEffect, useState } from 'react';
import StakedAntStats from './AntStatsStaked.js';
import BackButton from './BackButton';
import CenterContent from './CenterContent';
import StakeDiamond from './images/Icon_Diamond.png';
import StatsInitialimg from './images/Icon_Initial.png';
import StatsTimespentimg from './images/Icon_Time.png';
import StatsEarnedimg from './images/Icon_Earned.png';
import StatsTotalimg from './images/Icon_Total.png';
// Removed useWeb3 import
import Slider from 'react-slick';
import { toast } from 'react-hot-toast';
import Tooltip from './Tooltip.js';
import PremiumAnt from './images/ANT.png';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';
import useStakedAntDetails from '../hooks/useStakedAntDetails.js';
import useFetchNfts from '../hooks/useFetchNfts.js';
import { useSelector } from 'react-redux';
import { selectAppStakedNft } from '../store/appSlice.js';


function calculateApy(level) {
  const apyValues = [
    5.1, 5.3, 5.6, 6, 7.5, // Levels 1-5
    8.1, 8.8, 9.6, 10.5, 12.5, // Levels 6-10
    13.6, 14.8, 16.1, 17.5, 20, // Levels 11-15
    21.6, 23.3, 25.1, 27, 30, // Levels 16-20
    32.1, 34.3, 36.6, 39, 42.5, // Levels 21-25
    45.1, 47.8, 50.6, 53.5, 57.5, // Levels 26-30
    60.6, 63.8, 67.1, 70.5, 75, // Levels 31-35
    78.6, 62.3, 86.1, 90, 95, // Levels 36-40
  ];
  return level < 1 || level > apyValues.length ? 0 : apyValues[level - 1];
}

function parseStakedTimeToHours(stakedTime) {
  if (!stakedTime) return 0; // Return 0 if stakedTime is null or undefined

  // Adjust regex to match the format set in useStakedAntDetails
  const daysMatch = stakedTime.match(/(\d+)\sD/);
  const hoursMatch = stakedTime.match(/(\d+)\sH/);
  const days = daysMatch ? parseInt(daysMatch[1], 10) : 0;
  const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
  return days * 24 + hours;
}

function calculateEarnings(stakedAmount, apy, totalHours) {
  const yearlyInterest = stakedAmount * (apy / 100); // Annual earnings
  const hourlyInterest = yearlyInterest / (365 * 24); // Convert annual earnings to hourly
  return hourlyInterest * totalHours; // Earnings over the staked period
}

function WorkforceUnAssign({ goBack }) {
  const [antIndex, setANTIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const { handleAssignedNfts, handleUnStakeNFT, fetchAllBalances, fetchAssignedNfts } = useSolanaWeb3();
  const { fetchNfts } = useFetchNfts()
  const { nfts:stakedNFts, loading:initLoading }= useSelector(selectAppStakedNft)
  const { level, stakedTime, stakedAmount, antAddress } = useStakedAntDetails(stakedNFts[antIndex]?.address);


  const handleUnStake = async (address) => {
    setLoading(true);
    try {
      await handleUnStakeNFT(address);
      await fetchAllBalances()
      fetchNfts(10)
      await fetchAssignedNfts()
      setLoading(false);
      toast.success("ANT successfully redeemed!");
    } catch (error) {
      console.error("Unstaking error:", error);
      toast.error("Failed to redeem ANT. Please try again.");
      setLoading(false);
    } finally {
      
    }
  };
 
  // Calculate earnings when level, stakedTime, or stakedAmount changes
  const totalHours = parseStakedTimeToHours(stakedTime);
  const currentStakedNFTApy = calculateApy(level);
  const earnings = calculateEarnings(stakedAmount, currentStakedNFTApy, totalHours);
  
  return (
    <section id="dashboard-unassign">
      <div className="platform-container">
        <BackButton goBack={goBack} title="Workforce" />
        
        {initLoading?"Loading your ants...":
          (stakedNFts?.length > 0 ?
            <>
              <div className="center-content">
                <div className='w-[calc(32*var(--dynamic-vunit))]'>
                  <Slider dots={false} infinite={true} slidesToShow={1} slidesToScroll={1} initialSlide={antIndex} afterChange={(index) => setANTIndex(index)}>
                    {
                      stakedNFts.map((ant, index) => {
                        return (
                          <div key={index} className='flex flex-col items-center'>
                            <img src={ant.image } alt='' className='w-[calc(32*var(--dynamic-vunit))]' />
                          </div>
                        )
                      })
                    }
                  </Slider>
                </div>
              </div>
              <StakedAntStats stakedNftAddress={stakedNFts[antIndex]?.address} />
              <button id="select-button" disabled={loading} onClick={() => handleUnStake(stakedNFts[antIndex]?.address)}>
                <span>{loading ? "Loading..." : "REDEEM ANT"}</span>
              </button>
              <div className="rewards-main-container">
                <div className="ant-rewards-container">
                  <img src={StakeDiamond} alt="Diamond" />
                  <div className="rewards-text">
                    <p>APY</p>
                    <h1>{currentStakedNFTApy.toFixed(1)}%</h1>
                  </div>
                </div>
              </div>
              <div className="container-right">
                <h2>Stats</h2>
                <div className="container-right-data-holder">
                  <img src={StatsInitialimg} alt="Diamond" />
                  <div className="rewards-text"><p>Initial Stake</p><h1>{stakedAmount}</h1></div></div>
                <div className="container-right-data-holder">
                  <img src={StatsTimespentimg} alt="Diamond"/>
                  <div className="rewards-text"><p>Time Spent</p><h1>{stakedTime}</h1></div></div>
                <div className="container-right-data-holder">
                  <img src={StatsEarnedimg} alt="Diamond" />
                  <div className="rewards-text"><p>Rewards earned</p><h1>{earnings.toFixed(2)}</h1></div></div>
                <div className="container-right-data-holder">
                  <img src={StatsTotalimg} alt="Diamond" />
                  <div className="rewards-text"><p>Total</p><h1>{(stakedAmount + earnings).toFixed(2)}</h1></div></div>
              </div>
            </> : <h1>You haven't assigned ANTs</h1>)
        }
      </div>
    </section>
  );
}

export default WorkforceUnAssign;